import { createElement } from "react"

import { flow, tupled } from "fp-ts/es6/function"
import { identity, ifElse, is, prop } from "ramda"

export const div = (props, children) => createElement("div", props, children)

export const fromList = tupled(createElement)

export const withPlaceholder = flow(
  ifElse(prop("displayed"), prop("content"), prop("placeholder")),
  ifElse(is(Array), fromList, identity),
)
